import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { toast } from 'react-toastify';
import { apiClient, extractApiError } from '../api/axios';
import { API } from '../constants/api';

const initialState = {
  me: [],
  loading: false,
  error: '',

  courierMe: null,
};

export const fetchMe = createAsyncThunk('me/fetchMe', async (_, { rejectWithValue }) => {
  try {
    const response = await apiClient.get(API.me.profile);
    return response.data;
  } catch (error) {
    return rejectWithValue(extractApiError(error));
  }
});

export const fetchCourierMe = createAsyncThunk('me/fetchCourierMe', async (_, { rejectWithValue }) => {
  try {
    const response = await apiClient.get(API.me.courierMe);
    return response.data;
  } catch (error) {
    return rejectWithValue(extractApiError(error));
  }
});

export const meSlice = createSlice({
  name: 'me',
  initialState,
  extraReducers: (builder) => {
    builder.addCase(fetchMe.pending, (state) => {
      state.loading = true;
      state.error = '';
    });
    builder.addCase(fetchMe.fulfilled, (state, action) => {
      state.loading = false;
      state.me = action.payload;
    });
    builder.addCase(fetchMe.rejected, (state, action) => {
      toast.error(action.payload);
      state.loading = false;
      state.error = action.payload;
    });

    builder.addCase(fetchCourierMe.pending, (state) => {
      state.loading = true;
      state.error = '';
    });
    builder.addCase(fetchCourierMe.fulfilled, (state, action) => {
      state.loading = false;
      state.courierMe = action.payload;
    });
    builder.addCase(fetchCourierMe.rejected, (state, action) => {
      toast.error(action.payload);
      state.loading = false;
      state.error = action.payload;
    });
  },
  reducers: {
    reset: (state) => {
      state.me = [];
      state.loading = false;
      state.error = '';
    },
    resetCourierMe: (state) => {
      state.courierMe = null;
      state.loading = false;
      state.error = '';
    },
  },
});

export const { reset, resetCourierMe } = meSlice.actions;

export default meSlice.reducer;
